module.exports = __webpack_public_path__ + "img/gblogo2.dfe51eea.webp";